import {Component, OnInit, Input, Injector, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgControl, ControlValueAccessor} from '@angular/forms';
import {ProvidersService} from '../../../phone/config/providers/services/providers.service';

const SELECT_PROVIDER_SERVICE_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectServiceProvidersComponent)
};
@Component({
    selector: 'app-select-service-providers',
    template:`<select id="{{ id }}" name="{{ id }}" class="form-control" [(ngModel)]="selectedValue" [class.is-invalid]="!control.control.valid && submitted">
        <option value="" >Choose an option</option>
        <option value="default" >Default</option>
        <option [value]="p[valueType]" *ngFor="let p of providers">{{p.name}}</option>
    </select>
    `,
    styleUrls: ['./select-service-providers.component.scss'],
    providers:[SELECT_PROVIDER_SERVICE_VALUE_ACCESSOR]
})
export class SelectServiceProvidersComponent implements OnInit, ControlValueAccessor {

    _selectedValue: any;

    control: NgControl;

    providers: Array <any>;

  @Input() id:any;
  @Input() submitted:boolean=false;
  @Input() valueType:string;

  constructor(private providerService: ProvidersService,
              private  inj: Injector) { }

  ngOnInit() {

      this.providerService.getServiceProviders()
          .subscribe(result =>{
              this.providers=result;
          });
      this.control = this.inj.get(NgControl);
  }




  //get accessor
  get selectedValue(): any {
      return this._selectedValue; };

    //set accessor including call the onchange callback
    set selectedValue(v: any) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);

    }



    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    propagateChange = (_: any) => {};
    onTouched = (_: any) => {};

    //From ControlValueAccessor interface
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }



}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-service-providers/select-service-providers.component.ts